import React, { useEffect, useState } from "react";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import Loader from "../../Components/Loader/Loader";
import { useSelector } from "react-redux";
import { NOTIFICATION, getAllNotification, getNotificationCount, markAllSeen, markRead } from "../../Actions/actions";
import { useDispatch } from "react-redux";

export default function Notification() {
  const { loginData, notification, loader } = useSelector(state => state.userReducer);
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllNotification(loginData?.accessToken));
    dispatch(markAllSeen(loginData?.accessToken, () => {
      dispatch(getNotificationCount(loginData?.accessToken));
    }));
  }, []);


  return (
    <ParentComponent>
      <PrimaryHeader />

      {loader ? (
        <div className="flex items-center justify-center center">
          <Loader />
        </div>
      ) : (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg overflow-hidden">
          <table className="min-w-full text-left">
            <thead className="bg-[#361D3214]">
              <tr className="">
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[100px]">
                  Notification
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[120px]">
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {notification?.length > 0 ? (
                notification?.map((item, id) => (
                  <tr
                    onClick={() => {

                      if (!item?.isRead) {
                        dispatch(markRead(loginData?.accessToken, item.id, () => {
                          let not = notification
                          not[id].isRead = true
                          dispatch({
                            type: NOTIFICATION,
                            payload: [...not],
                          });
                        }));
                      }
                    }}
                    key={item?.notification?.id}
                    className="border-b last:border-0 cursor-pointer"
                  >
                    <td className="py-4 px-4 text-gray-800 text-sm font-medium min-w-[120px] flex items-start gap-2">


                      <div>
                        <p className="text-left font-semibold text-md text-gray-800">
                          {item?.notification?.title || 'No Title'}
                        </p>
                        <p className="text-left font-medium text-xs text-gray-600 mt-1">
                          {item?.notification?.description || 'No description available.'}
                        </p>
                      </div>
                    </td>
                    <td className="py-4 px-4 text-left font-medium text-xs text-gray-600 min-w-[150px]">
                      {item?.notification?.creationDate
                        ? new Date(item?.notification?.creationDate).toLocaleDateString('en-GB')
                        : 'No Date'}
                      {!item?.isRead && (
                        <span className="w-2 h-2 mt-2 rounded-full bg-primary inline-block ml-5"></span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-gray-500 py-4">
                    No Notification found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      )}

    </ParentComponent>
  );
}
